module.exports = __webpack_public_path__ + "img/Guam.0cc44317.svg";